import template from './start-view.template.html';
import {StartViewController} from './start-view.controller';

export const StartViewComponent = {
    templateUrl: template,
    controller: StartViewController
};



// WEBPACK FOOTER //
// ./src/js/views/start-view/start-view.component.js